import { has } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forCenter" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refPayBy", "refBank", "branch", "branchCode", "refType", "bankCust", "bankAccount", "bankName"].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCenter" })) {
                    enabled = !viewOnly || enabled;
                }
                enabled = false; // wait requirements
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refStatus"].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCenter" })) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let canCreate = false;
                let canDelete = false;
                if (has({ menuContext, key: "forCenter" })) {
                    enabled = !viewOnly || enabled;
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                enabled = false; // wait requirements
                canCreate = false; // wait requirements
                canDelete = false; // wait requirements
                return { viewOnly: !enabled, canCreate, canDelete };
            }
        }
    ];
};
